import { render, staticRenderFns } from "./LoginInfoAdmin.vue?vue&type=template&id=27250b84&"
import script from "./LoginInfoAdmin.vue?vue&type=script&lang=js&"
export * from "./LoginInfoAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports